import produce from 'immer';
import { createSelector } from 'reselect';

import {
  SET_VIEWPORT_MOBILE
} from 'app/actions/types';

const initialState = {
  isMobile: false
}

export default function(state = initialState, action) {
  switch (action.type) {
    case SET_VIEWPORT_MOBILE:
      return produce(state, draft => {
        draft.isMobile = action.payload;
      });

    default:
      return state;
  }
}

const selectViewportReducer = state => state.viewportReducer;

export const selectViewportMobile = createSelector(selectViewportReducer, state => {
  return state.isMobile;
});
